module.exports = __webpack_public_path__ + "static/3-ebe423e577abb0ade2d92df5e41926d7.jpg";